// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oVe1hEQ96FkDteDTn1cz{justify-content:center;align-items:center;padding:10px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loaderWrap": `oVe1hEQ96FkDteDTn1cz`
};
export default ___CSS_LOADER_EXPORT___;
